import { Box, Button, InputLabel, Stack, Typography } from "@mui/material";
import ModalContainer from "../UIElements/modal-container";
import { useTheme } from "@mui/material/styles";
import { TextArea } from "../UIElements/input-ui";
import { labelSty } from "../UIElements/styles-input";
import SelectInput from "../UIElements/select";
import { useMutation } from "@tanstack/react-query";
import { useNotificationService } from "../notification";
import { apiSubmitIssue } from "../../api/users";
import { useState } from "react";
import { LoadingButton } from "@mui/lab";

export const ProfileReportModal = ({ open, handleModal }: any) => {
  const theme = useTheme();
  const { showNotification } = useNotificationService();
  const [state_data, setState_data] = useState({
    issue_type: "",
    description: "",
  });

  const mutation = useMutation({
    mutationFn: (fieldValues: { issue_type: string; description: string }) =>
      apiSubmitIssue(fieldValues),
    onSuccess: (data) => {
      // Handle error
      if (data?.status === "error") {
        if ("msg" in data) {
          showNotification(data?.msg ?? "", "error");
          return;
        }
      }
      //  Handle success
      if ("data" in data) {
        showNotification(data?.data?.message ?? "", "success");
        handleModal();
        setState_data({
          issue_type: "",
          description: "",
        });
      }
    },
    onError: (error) => {
      console.error("Issue not sent", error);
      // Handle error
      showNotification("Issue not sent", "error");
    },
  });

  const handleSubmit = () => {
    if (state_data?.description === "" || state_data?.issue_type === "") {
      showNotification("Kindly fill the form to report an issue", "warning");
    } else {
      mutation.mutate(state_data);
    }
  };
  return (
    <ModalContainer
      sx={{
        borderRadius: "16px",
      }}
      size={"xs"}
      openModal={open}
      fullWidth={true}
      handleModal={handleModal}
    >
      <Box sx={{ background: "#fff", padding: 3, borderRadius: "16px" }}>
        <Typography
          variant="h6"
          sx={{
            fontFamily: "Outfit",
            fontWeight: 500,
            color: "#292925",
          }}
        >
          Report an Issue
        </Typography>
        <Box component={"form"}>
          <Stack sx={{ my: 3 }}>
            <SelectInput
              label="Reason"
              value={state_data?.issue_type}
              onChange={(e) =>
                setState_data((prev) => ({
                  ...prev,
                  issue_type: e.target.value,
                }))
              }
              options={[
                { value: "", label: "Select an Issue" },
                { value: "Access Issue", label: "Access Issue" },
                { value: "Medic Data", label: "Medic Data" },
                { value: "Validations Error", label: "Validations Error" },
              ]}
            />
          </Stack>

          <Stack sx={{ my: 3 }}>
            <InputLabel sx={{ ...labelSty }}>Description </InputLabel>

            <TextArea
              placeholder={"Enter text here."}
              value={state_data?.description}
              onchange={(e: any) =>
                setState_data((prev) => ({
                  ...prev,
                  description: e.target.value,
                }))
              }
            />
          </Stack>
          <Stack
            direction={"row"}
            justifyContent={"space-around"}
            sx={{ gap: 3 }}
          >
            <Button
              onClick={handleModal}
              sx={{
                width: 150,
                borderRadius: "12px",
                background: theme.palette.lightBlue.light,
              }}
              variant="outlined"
            >
              Cancel
            </Button>
            <LoadingButton
              loading={mutation.isPending}
              onClick={handleSubmit}
              sx={{ width: 150, borderRadius: "12px" }}
              variant="contained"
            >
              Done
            </LoadingButton>
          </Stack>
        </Box>
      </Box>
    </ModalContainer>
  );
};
